import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { T4CommonModule } from '../../t4common/t4common';
import { AuthGuard } from 't4core';
import { BookingsComponent } from './views/bookings/bookings.component';
import { OneWayComponent } from './views/oneway/oneway.component';
import { GeneralComponent } from './views/general/general.component';
import { FleetComponent } from './views/fleet/fleet.component';
import { MaintenanceComponent } from './views/maintenance/maintenance.component';
import { DrivingComponent } from './views/driving/driving.component';
import { T4coreModule } from 't4core';
import { SupportDashboardComponent } from './views/SupportDashboard/SupportDashboard';
import { ServiceStatusComponent } from './views/ServiceStatus/ServiceStatus';
import { HelpCenterComponent } from './views/HelpCenter/HelpCenter';

@NgModule({
    declarations: [
        BookingsComponent,
        GeneralComponent,
        OneWayComponent,
        FleetComponent,
        MaintenanceComponent,
    DrivingComponent,
    SupportDashboardComponent,
    ServiceStatusComponent,
    HelpCenterComponent
    ],
    imports: [
      T4CommonModule,
      T4coreModule,
        RouterModule.forChild([
            {
                path: 'Support',
                data: {
                    index: 20001, title: "Support", toolTip: "Help & Support", icon: 'help'
                },
                children: [
                    { path: '', redirectTo: 'Dashboard', pathMatch: 'full' },
                    {
                      path: "Dashboard",
                        component: SupportDashboardComponent,
                        data: { title: "Start", toolTip: "Start", icon: 'home' }
                    },
                  {
                    path: "HelpCenter",
                    redirectTo: "https://brenderuprental.zendesk.com/hc/en-us",
                    data: { title: "Help center", uri: 'https://brenderuprental.zendesk.com/hc/en-us', target: '_blank', icon: 'home' }
                  },
                  {
                    path: "ServiceStatus",
                    component: ServiceStatusComponent,
                    data: { title: "Service status", icon: 'home' }
                  },
                ]
            },
           
            
        ])
    ],
    providers: [T4CommonModule],
})
export class Support {
    public static theme: string = "unicorn-dark-theme";
}
